import Vue from "vue";

export default {
  setupStoreVars: (state, payload) => {
    for (let key in payload) {
      Vue.set(state, key, payload[key]);
    }
  },

  setSensitivityLabels: (state, labels) => {
    labels.forEach(label => {
      const lbl = JSON.parse(label.value);
      state.sensitivityLabels[label.key] = lbl;
    });
  },

  createSensitivityLabel: (state, label) => {
    const labels = Object.assign({}, state.sensitivityLabels);
    labels[label.label.toLowerCase()] = label;
    Vue.set(state, "sensitivityLabels", labels);
  },

  deleteSensitivityLabel: (state, label) => {
    const labels = Object.assign({}, state.sensitivityLabels);
    delete labels[label.label.toLowerCase()];
    Vue.set(state, "sensitivityLabels", labels);
  }
};
